import * as React from "react";
import "./App.css";
import Intro from "./components/Intro";
import UserInfo from "./components/UserInfo";
import Questions from "./components/Questions";
import Graph from "./components/Graph";
import Results from "./components/Results";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
// const _ = require("lodash");

// Import data from JSON files
import * as dataQuestionsEmployee from "./data.questions.employee.json";
import * as dataQuestionsEmployer from "./data.questions.employer.json";
const questions = {
  employee: dataQuestionsEmployee,
  employer: dataQuestionsEmployer
};

const isLocalhost = () => location.host && location.host != "localhost:1444";

// Analytics - Init
// ********************************* UPDATE **************************************
ReactGA.initialize("UA-118481583-1", {
  debug: true
  //   titleCase: false,
  //   gaOptions: {
  //     userId: 123
  //   }
});
// Analytics - Hit
// ********************************* UPDATE **************************************
if (isLocalhost()) {
  ReactGA.pageview("init-pageview");
}

const total = (weightings: any[]) => {
  // return weightings.reduce((acc: any, current: any) => {
  //   return acc + current.value;
  // }, 0);
  // ^ come back to this later, it's being weird
  let total = 0;
  weightings.forEach(w => {
    total += w;
  });
  return total;
};

const balanceWeightings = (weightings: any[]) => {
  return weightings.map(w => {
    // console.log(total(weightings), i);
    return total(weightings) != 0 ? (w / total(weightings)) * 100 : 0; // percentages
  });
};

const extractGivenAnswers = (answers: any[]) => {
  return answers.map(a => {
    if (a.answerChosen != null) {
      a.answer = a.answers[a.answerChosen];
    }
    return a;
  });
};

class App extends React.Component<
  {},
  {
    //:: this.state                                    ::
    //:: https://stackoverflow.com/a/475625985/3098773 ::
    debugging: boolean;
    page: string;
    questions: any[];
    employmentType: string;
    currentQuestion: number;
    readyToProceed: boolean;
    company: string;
    userInfo: any[];
    weightings: number[];
    weightingsNew: any[];
    weightingsBalanced: any[];
    questionsAndAnswers: any[];
  }
> {
  constructor(props: any) {
    super(props);

    // Bind context to this (App.tsx) for functions that we pass to components as needed
    this.setEmploymentType = this.setEmploymentType.bind(this);
    this.updateWeightings = this.updateWeightings.bind(this);
    this.userInfoSubmitted = this.userInfoSubmitted.bind(this);
    this.goTo = this.goTo.bind(this);
  }

  componentDidMount() {
    this.setState({
      debugging: window.location.hostname === "localhost",
      page: "intro",
      employmentType: "",
      currentQuestion: 0,
      weightings: [1, 1, 1, 1],
      weightingsBalanced: [25, 25, 25, 25]
    });
  }

  setEmploymentType(employmentType: string) {
    this.setState({
      employmentType: employmentType,
      questions: questions[employmentType]
    });
    this.goTo("userInfo");
  }

  calcWeightingsFromQuestions = (questionsAndAnswers: any[]) => {
    // Filter out questions that haven't been answered
    let answers = questionsAndAnswers.filter(q => q.answer != null);

    // Loop over answers, compounding the weightings so far
    let weightings = [1, 1, 1, 1];
    answers.forEach(a => {
      weightings = a.answer.weightings.map(
        (w: number, i: number) => weightings[i] + w
      );
    });
    return weightings;
  };

  updateWeightings() {
    // !!!!
    // weightingsBalanced are balanced percentages only for display,
    // whereas weightings increments up arbitrarily -
    // SEE README for more info!
    // !!!!
    this.setState(
      {
        weightings: this.calcWeightingsFromQuestions(
          this.state.questionsAndAnswers
        )
      },
      () => {
        this.setState(
          {
            weightingsBalanced: balanceWeightings(this.state.weightings),
            readyToProceed: true
          },
          () => {
            // console.log("weightings", this.state.weightings);
            // console.log("weightingsBalanced", this.state.weightingsBalanced);
          }
        );
      }
    );
  }

  goTo(target: string) {
    this.setState({
      page: target
    });
  }

  nextQuestion() {
    // Tell parent iframe to scroll up
    if (
      (window as any).parentSource &&
      (window as any).parentSource.postMessage
    ) {
      (window as any).parentSource.postMessage(
        { futureOfTheWorkforceScrollUp: true },
        "*"
      );
    }
    this.setState({
      currentQuestion: this.state.currentQuestion + 1,
      readyToProceed: false
    });

    // Analytics - Question answered
    // ********************************* UPDATE **************************************
    if (isLocalhost()) {
      ReactGA.event({
        category: "Answers",
        action: String(this.state.currentQuestion + 1),
        // Need to bubble up the actual answer.
        // To be honest, I need advice from (maybe both Chris'es?) about how this'll be structured
        label: ""
      });
    }
  }

  previousQuestion() {
    // Tell parent iframe to scroll up
    if (
      (window as any).parentSource &&
      (window as any).parentSource.postMessage
    ) {
      (window as any).parentSource.postMessage(
        { futureOfTheWorkforceScrollUp: true },
        "*"
      );
    }
    this.setState({
      currentQuestion: this.state.currentQuestion - 1
      //   readyToProceed: false
    });
  }

  trackResultsView() {
    // Analytics - Results View
    // ********************************* UPDATE **************************************
    if (isLocalhost()) {
      ReactGA.event({
        category: "Results",
        action: "View",
        label: ""
      });
    }
  }

  //
  // DEBUGGING DATA FOR RESULTS SHORTCUT (EMPLOYEE)
  //
  resultsShortcutEmployee() {
    let weightings = [6, 6, 7, 4];
    this.setState({
      page: "results",
      weightings: weightings,
      weightingsBalanced: balanceWeightings(weightings),
      employmentType: "employee",
      company: "techdept",
      userInfo: [
        { name: "age", answer: "35-53" },
        { name: "companySize", answer: "250 - 1000 employees (mid)" },
        { name: "gender", answer: "Female" },
        { name: "region", answer: "Midlands" },
        { name: "wageBracket", answer: "£24k - £31,999" }
      ],
      questionsAndAnswers: [
        {
          content: "Imaginary question 1",
          answer: { content: "Imaginary answer 1" }
        },
        {
          content: "Imaginary question 2",
          answer: { content: "Imaginary answer 2" }
        }
      ]
    });
  }

  //
  // DEBUGGING DATA FOR RESULTS SHORTCUT (EMPLOYER)
  //
  resultsShortcutEmployer() {
    let weightings = [6, 6, 7, 4];
    this.setState({
      page: "results",
      weightingsBalanced: balanceWeightings(weightings),
      employmentType: "employer",
      company: "getahead",
      userInfo: [
        { name: "companySize", answer: "1000+ employees (large)" },
        { name: "employmentType", answer: "employer" },
        { name: "region", answer: "South West" },
        { name: "sector", answer: "Labour/Agriculture/Farming" }
      ],
      questionsAndAnswers: [
        {
          content: "Imaginary question 1",
          answer: { content: "Imaginary answer 1" }
        },
        {
          content: "Imaginary question 2",
          answer: { content: "Imaginary answer 2" }
        }
      ]
    });
  }

  // Redundant?
  passQuestionsAndAnswers(questionsAndAnswers: any) {
    this.setState(
      { questionsAndAnswers: extractGivenAnswers(questionsAndAnswers) },
      () => {
        this.updateWeightings();
        // console.log(this.state.questionsAndAnswers);
      }
    );
  }

  userInfoSubmitted(info: any) {
    this.setState({ company: info.company, userInfo: info.userInfo });
    this.goTo("questions");
  }

  render() {
    if (!this.state || !this.state.page) {
      return null; // loading
    }

    {
      this.state.page === "results" && this.trackResultsView();
    }

    return (
      <div className={"renderer page--" + this.state.page}>
        <Helmet>
          {/* Inject og meta data for facebook sharing  */}
          <meta
            property="og:url"
            content={encodeURIComponent(String(window.location))}
          />
          <meta property="og:type" content="article" />
          {/* If the facebook share link is to create a post that contains the
          user's result, then this needs to look at the hash in the shared link,
          e.g. #result-employee-2 and use that to figure out a title with the data from json  */}
          <meta
            property="og:title"
            content="The Future Workforce: How prepared are you and your business?"
          />
          <meta
            property="og:description"
            content="A fun and engaging interactive quiz to find out which working 'tribe' you belong to."
          />
          {/* To do: Ed will produce a tidy image for the facebook share link: */}
          {/* <meta property="og:image" content="http://foo.com/foo.jpg" /> */}
        </Helmet>

        {/* <h1>The Future Workforce: How prepared are you and your business?</h1>
        <img src="/images/woman-phone.png" width="500" /> */}
        {this.state.page === "intro" && (
          <main className="intro">
            <Intro setEmploymentType={this.setEmploymentType} />

            {this.state.debugging && (
              <div className="debugging_links">
                <h3>Debugging (only visible on localhost):</h3>
                <button
                  className="button--debugging"
                  onClick={this.resultsShortcutEmployee.bind(this)}
                >
                  RESULTS SHORTCUT EMPLOYEE
                </button>
                <button
                  className="button--debugging"
                  onClick={this.resultsShortcutEmployer.bind(this)}
                >
                  RESULTS SHORTCUT EMPLOYER
                </button>
              </div>
            )}
          </main>
        )}
        {this.state.page === "userInfo" && (
          <main className="intro">
            <UserInfo
              employmentType={this.state.employmentType}
              userInfoSubmitted={this.userInfoSubmitted}
            />
          </main>
        )}

        {this.state.page === "questions" && (
          <main>
            <h1>
              The Future Workforce: How prepared are you and your business?
            </h1>
            <Questions
              questions={this.state.questions}
              currentQuestion={this.state.currentQuestion}
              updateWeightings={this.updateWeightings}
              nextQuestion={this.nextQuestion.bind(this)}
              previousQuestion={this.previousQuestion.bind(this)}
              readyToProceed={this.state.readyToProceed}
              passQuestionsAndAnswers={this.passQuestionsAndAnswers.bind(this)}
              goTo={this.goTo}
            />
            <Graph weightings={this.state.weightingsBalanced} />
          </main>
        )}

        {this.state.page === "results" && (
          <Results
            questionsAndAnswers={this.state.questionsAndAnswers}
            employmentType={this.state.employmentType}
            weightings={this.state.weightingsBalanced}
            company={this.state.company}
            userInfo={this.state.userInfo}
          />
        )}
      </div>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.tsx